/* Subscription plan switcher for cart lines (drawer and cart page).
   Posts the chosen selling plan to /cart/change.js and re-renders the
   cart sections through the surrounding cart-items element, the same
   way the quantity stepper does. */
if (!customElements.get('cart-plan-select')) {
  customElements.define(
    'cart-plan-select',
    class CartPlanSelect extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', this.onChange.bind(this));
      }

      onChange(event) {
        // keep the cart-items quantity handler from seeing this change
        event.stopPropagation();
        const select = event.target;
        if (!select.matches('select[name="selling_plan"]')) return;
        const cartItems = this.closest('cart-items, cart-drawer-items');
        if (!cartItems) return;

        const line = select.dataset.index;
        const option = select.selectedOptions[0];
        const bundleQuantity = parseInt(option.dataset.quantity, 10);
        const quantity = bundleQuantity > 0 ? bundleQuantity : parseInt(select.dataset.quantity, 10);
        const sellingPlan = select.value ? parseInt(select.value, 10) : null;

        cartItems.enableLoading(line);

        const body = JSON.stringify({
          line,
          quantity,
          selling_plan: sellingPlan,
          sections: cartItems.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.text())
          .then((state) => {
            const parsedState = JSON.parse(state);
            if (parsedState.errors) {
              cartItems.updateLiveRegions(line, parsedState.errors);
              return;
            }

            cartItems.getSectionsToRender().forEach((section) => {
              const target = document.getElementById(section.id);
              if (!target) return;
              const elementToReplace = target.querySelector(section.selector) || target;
              elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });
            cartItems.updateLiveRegions(line, '');

            const lineItem =
              document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            const nextSelect = lineItem && lineItem.querySelector('select[name="selling_plan"]');
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            if (nextSelect) {
              cartDrawerWrapper ? trapFocus(cartDrawerWrapper, nextSelect) : nextSelect.focus();
            }

            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
          })
          .catch(() => {
            const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
            if (errors) errors.textContent = window.cartStrings.error;
          })
          .finally(() => {
            cartItems.disableLoading(line);
          });
      }
    }
  );
}
